import { Waypoint } from '@omniafishing/core';
import React, { useCallback } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useDispatch } from 'react-redux';
import { apiV1 } from '../../../../lib/api';
import { objectToFormData } from '../../../../lib/form';
import { WebAnalytics } from '../../../../lib/web_analytics';
import { FlashMessageActions } from '../../../../redux/flash_message';
import { SvgShare } from '../../../svg/share';
import styles from './share_waypoint_button.less';

interface ShareWaypointButtonProps {
  waypoint: Waypoint;
  Button?: React.ReactElement;
}

export const appsFlyerOneLinkWaypoints = 'https://go.omniafishing.com/gZRj/dbd8o83b';
export const getWaypointShareUrl = (waypoint: Waypoint) => {
  return `${appsFlyerOneLinkWaypoints}?waypoint_hash=${waypoint.id_hash}`;
};

export const ShareWaypointButton = (props: ShareWaypointButtonProps) => {
  const { waypoint, Button } = props;
  const dispatch = useDispatch();

  const fullWaypointUrl = getWaypointShareUrl(waypoint);

  const shareData = {
    url: fullWaypointUrl,
  };

  const updateWaypointToPublic = useCallback(async () => {
    try {
      const formData = objectToFormData({ public: true });
      await apiV1.waypointUpdate(waypoint.id, formData);
    } catch (error) {
      dispatch(
        FlashMessageActions.FLASH_MESSAGE_SET({
          header: 'Error',
          subheader:
            'We had a problem making your waypoint public so you can share. Please try again.',
        })
      );
    }
  }, [waypoint.id]);

  const handleNavigatorClick = () => {
    updateWaypointToPublic();
    dispatch(
      FlashMessageActions.FLASH_MESSAGE_SET({
        header: 'Link Copied',
        subheader: 'A link to this waypoint has been copied to your clipboard.',
      })
    );
    navigator
      .share(shareData)
      .then(() => {
        WebAnalytics.waypointShared({
          id_hash: waypoint.id_hash,
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  return (
    <>
      {typeof navigator !== 'undefined' && navigator.canShare?.(shareData) ? (
        <CopyToClipboard text={fullWaypointUrl} onCopy={handleNavigatorClick}>
          {Button ? (
            Button
          ) : (
            <div className={styles.shareButton}>
              <button>
                <SvgShare />
              </button>
              Share
            </div>
          )}
        </CopyToClipboard>
      ) : (
        <CopyToClipboard
          text={fullWaypointUrl}
          onCopy={() => {
            updateWaypointToPublic();
            dispatch(
              FlashMessageActions.FLASH_MESSAGE_SET({
                header: 'Link Copied',
                subheader: 'A link to this waypoint has been copied to your clipboard.',
              })
            );
            WebAnalytics.waypointShared({
              id_hash: waypoint.id_hash,
            });
          }}
        >
          {Button ? (
            Button
          ) : (
            <div className={styles.shareButton}>
              <button>
                <SvgShare />
              </button>
              Share
            </div>
          )}
        </CopyToClipboard>
      )}
    </>
  );
};
